// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3hOK3","requiredAsterisk":"Info_requiredAsterisk__F2Rgn"};